import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AzavistaApiService, IProcessFull, IResumeProcessRequest } from '@azavista/servicelib';
import { IStopProcessDialogComponentResult } from './stop-process-dialog/declarations';
import { StopProcessDialogComponent } from './stop-process-dialog/stop-process-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ProcessesSharedService {
    constructor(
        private readonly apiSvc: AzavistaApiService,
        private readonly matDialog: MatDialog
    ) { }

    async onFlowPausedChanged(paused: boolean, fullProcess: IProcessFull): Promise<boolean> {
        try {
            if (paused) {
                await this.apiSvc.pauseProcess(fullProcess.id);
            } else {
                const stopProcessDialogResult = await this.showStopProcessDialog();
                if (!stopProcessDialogResult) {
                    return false;
                }
                const req: IResumeProcessRequest = {
                    restart_old_process: stopProcessDialogResult.publishSavedMessages
                };
                await this.apiSvc.resumeProcess(fullProcess.id, req);
            }
            fullProcess.paused = paused;
        } catch (e) {

        }
        return true;
    }

    private async showStopProcessDialog(): Promise<IStopProcessDialogComponentResult> {
        return new Promise(resolve => {
            this.matDialog.open<StopProcessDialogComponent, void, IStopProcessDialogComponentResult>(StopProcessDialogComponent)
                .afterClosed().subscribe(dlgResult => {
                    resolve(dlgResult);
                });
        });
    }
}
